import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    bookedPL: 0,
    unbookedPL: 0,
    totalPL: 0,
    posRefreshTriggered: false,
    positionDetail: [],
    positionUpdateSocketTrigger: null
};
export const plSlice = createSlice({
    name: "pl-state",
    initialState: initialState,
    reducers: {
        setBookedPLValue(state, action) {
            state.bookedPL = action.payload;
        },
        setUnbookedPLValue(state, action) {
            state.unbookedPL = action.payload;
        },
        setTotalPLValue(state, action) {
            state.totalPL = action.payload;
        },
        setPositionDetail(state, action) {
            state.positionDetail = action.payload;
        },
        setPositionRefreshTriggered(state, action) {
            state.posRefreshTriggered = action.payload;
        },
        positionUpdateSocketTrigger(state, action) {
            state.positionUpdateSocketTrigger = action.payload;
        },
    },
});
export const { setBookedPLValue, setUnbookedPLValue, setTotalPLValue, setPositionRefreshTriggered, setPositionDetail, positionUpdateSocketTrigger } = plSlice.actions;
export default plSlice.reducer;
